import { handleResponse, requestTimeout } from "../utils";

const apiUrl = process.env.REACT_APP_API_URL;
const apiMaxTime = process.env.REACT_APP_API_EXEC_TIME;

export const dashboardApi = {
  _get,
};

async function _get() {
  let token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);

  const requestOptions = {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };

  let result = await requestTimeout(
    apiMaxTime,
    fetch(apiUrl + "dashboard/data", requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
  return result;
}
